import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
export function rotatePoints(points, center, degrees) {
  if (points && points.length) {
    var _center = _slicedToArray(center, 2),
        cx = _center[0],
        cy = _center[1];

    var angle = Math.PI / 180 * degrees;
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    points.forEach(function (p) {
      var _p = _slicedToArray(p, 2),
          x = _p[0],
          y = _p[1];

      p[0] = (x - cx) * cos - (y - cy) * sin + cx;
      p[1] = (x - cx) * sin + (y - cy) * cos + cy;
    });
  }
}
export function rotateLines(lines, center, degrees) {
  var points = [];
  lines.forEach(function (line) {
    return points.push.apply(points, _toConsumableArray(line));
  });
  rotatePoints(points, center, degrees);
}
export function lineLength(line) {
  var p1 = line[0];
  var p2 = line[1];
  return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2));
}